export interface BankAccountState {
  isLoadingAllies: boolean
  isCreateBankAccountModalOpen: boolean
  isEditBankAccountModalOpen: boolean
  isSetDefaultBankAccountModalOpen: boolean
  selectedBankAccountId: string | null
  selectedCommercialAllyId: string | null
}

export const initialState: BankAccountState = {
  isLoadingAllies: false,
  isCreateBankAccountModalOpen: false,
  isEditBankAccountModalOpen: false,
  isSetDefaultBankAccountModalOpen: false,
  selectedBankAccountId: null,
  selectedCommercialAllyId: null
}
